export * from "./GridCellContentTooltip"

export function cx(...classes: (string | any)[]) {
  return classes.filter((s) => s).join(' ');
}
